module.exports = __webpack_public_path__ + "static/img/img4-2.a4d5f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202403/img4-2.jpg
// module id = /31p
// module chunks = 0